import React from 'react';

import { DiplomaPageLayout } from './DiplomaPageLayout';

const DiplomaPageContainer: React.FC = () => {

	return (
		<React.Fragment>
			<DiplomaPageLayout/>
		</React.Fragment>
	);
};

export default DiplomaPageContainer;